import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, Leaf, Users, Award, Globe } from 'lucide-react';
const About = () => {
  return <div className="bg-[#f8f9f4] min-h-screen w-full" data-id="element-522">
      {/* Hero Section */}
      <div className="relative bg-[#f0f7eb] py-20" data-id="element-523">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-524">
          <div className="max-w-3xl mx-auto text-center" data-id="element-525">
            <Link to="/" className="inline-flex items-center text-[#2e7d32] font-medium mb-8 hover:text-[#1b5e20] transition-colors duration-300" data-id="element-526">
              <ArrowLeftIcon className="mr-2 h-4 w-4" data-id="element-527" />
              Back to Home
            </Link>
            <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-528">Our Story</h1>
            <div className="w-16 h-1 bg-[#2e7d32] mx-auto mb-6" data-id="element-529"></div>
            <p className="text-gray-600 text-lg" data-id="element-530">
              Discover how Shiriaka Essentials is bringing the healing power of
              Kenya's botanical treasures to the world.
            </p>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full h-16 bg-white" style={{
        clipPath: 'polygon(0 100%, 100% 0, 100% 100%, 0% 100%)'
      }} data-id="element-531"></div>
      </div>
      {/* Our Mission */}
      <section className="py-16 bg-white" data-id="element-532">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-533">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-534">
            <div data-id="element-535">
              <div className="inline-flex items-center px-4 py-2 bg-[#f0f7eb] text-[#2e7d32] text-sm font-medium rounded-full mb-6" data-id="element-536">
                <span data-id="element-537">Our Mission</span>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-538">
                Bringing Nature's Healing Power to Your Daily Life
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-539">
                At Shiriaka Essentials, our mission is to harness Kenya's rich
                botanical diversity to create premium quality essential oils
                that enhance wellbeing. We are committed to sustainable
                practices that protect our environment while supporting local
                communities.
              </p>
              <p className="text-gray-600" data-id="element-540">
                We believe in the power of nature to heal, rejuvenate, and
                balance. Every product we create is designed to bring the
                therapeutic benefits of plants into your daily routine in the
                purest form possible.
              </p>
            </div>
            <div className="relative" data-id="element-541">
              <img src="https://images.unsplash.com/photo-1564515963098-cb5ee5c1f4f7?q=80&w=600&auto=format&fit=crop" alt="Essential oil production" className="rounded-lg shadow-xl w-full object-cover" onError={e => {
              e.currentTarget.src = 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?q=80&w=600&auto=format&fit=crop';
            }} data-id="element-542" />
              <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg hidden md:block" data-id="element-543">
                <div className="flex items-center space-x-3" data-id="element-544">
                  <div className="w-10 h-10 rounded-full bg-[#e8f5e9] flex items-center justify-center" data-id="element-545">
                    <Leaf className="h-5 w-5 text-[#2e7d32]" data-id="element-546" />
                  </div>
                  <div data-id="element-547">
                    <p className="font-medium text-gray-900" data-id="element-548">Est. 2015</p>
                    <p className="text-sm text-gray-500" data-id="element-549">Nairobi, Kenya</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Our Values */}
      <section className="py-16 bg-[#f8f9f4]" data-id="element-550">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-551">
          <div className="text-center mb-16" data-id="element-552">
            <div className="inline-flex items-center px-4 py-2 bg-[#e8f5e9] text-[#2e7d32] text-sm font-medium rounded-full mb-4" data-id="element-553">
              <span data-id="element-554">Our Values</span>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-555">
              The Principles That Guide Us
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-556">
              Every decision we make is guided by our core values that
              prioritize quality, sustainability, and community.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-557">
            <div className="bg-white rounded-xl shadow-md p-8" data-id="element-558">
              <div className="w-14 h-14 bg-[#f0f7eb] rounded-full flex items-center justify-center mb-6" data-id="element-559">
                <Leaf className="h-7 w-7 text-[#2e7d32]" data-id="element-560" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-561">
                Purity & Quality
              </h3>
              <p className="text-gray-600" data-id="element-562">
                We maintain the highest standards of purity in our essential
                oils. Each batch undergoes rigorous testing to ensure it meets
                our quality benchmarks before reaching our customers.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-8" data-id="element-563">
              <div className="w-14 h-14 bg-[#f0f7eb] rounded-full flex items-center justify-center mb-6" data-id="element-564">
                <Globe className="h-7 w-7 text-[#2e7d32]" data-id="element-565" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-566">
                Sustainability
              </h3>
              <p className="text-gray-600" data-id="element-567">
                Our farming practices prioritize environmental sustainability.
                We work closely with farmers to ensure responsible cultivation
                methods that preserve Kenya's natural resources for future
                generations.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-8" data-id="element-568">
              <div className="w-14 h-14 bg-[#f0f7eb] rounded-full flex items-center justify-center mb-6" data-id="element-569">
                <Users className="h-7 w-7 text-[#2e7d32]" data-id="element-570" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-571">
                Community Support
              </h3>
              <p className="text-gray-600" data-id="element-572">
                We believe in fair trade and supporting local communities. By
                partnering with small-scale farmers across Kenya, we help create
                sustainable livelihoods while obtaining the finest botanical
                ingredients.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Our Process */}
      <section className="py-16 bg-white" data-id="element-573">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-574">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-575">
            <div className="inline-flex items-center px-4 py-2 bg-[#e8f5e9] text-[#2e7d32] text-sm font-medium rounded-full mb-4" data-id="element-576">
              <span data-id="element-577">Our Process</span>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-578">
              From Plant to Bottle
            </h2>
            <p className="text-gray-600" data-id="element-579">
              We take pride in our meticulous process that ensures every drop of
              essential oil captures the true essence of the plant.
            </p>
          </div>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-580">
            <div className="text-center" data-id="element-581">
              <div className="w-16 h-16 bg-[#f0f7eb] rounded-full flex items-center justify-center mx-auto mb-6 relative" data-id="element-582">
                <span className="text-[#2e7d32] font-bold text-xl" data-id="element-583">1</span>
                <div className="absolute top-1/2 left-full h-0.5 w-full bg-[#e8f5e9] -translate-y-1/2 hidden md:block" data-id="element-584"></div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-585">
                Sustainable Cultivation
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-586">
                We partner with farmers who use organic and sustainable growing
                methods to cultivate the finest botanical ingredients.
              </p>
            </div>
            <div className="text-center" data-id="element-587">
              <div className="w-16 h-16 bg-[#f0f7eb] rounded-full flex items-center justify-center mx-auto mb-6 relative" data-id="element-588">
                <span className="text-[#2e7d32] font-bold text-xl" data-id="element-589">2</span>
                <div className="absolute top-1/2 left-full h-0.5 w-full bg-[#e8f5e9] -translate-y-1/2 hidden md:block" data-id="element-590"></div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-591">
                Careful Harvesting
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-592">
                Plants are harvested at their peak to ensure the highest
                concentration of beneficial compounds.
              </p>
            </div>
            <div className="text-center" data-id="element-593">
              <div className="w-16 h-16 bg-[#f0f7eb] rounded-full flex items-center justify-center mx-auto mb-6 relative" data-id="element-594">
                <span className="text-[#2e7d32] font-bold text-xl" data-id="element-595">3</span>
                <div className="absolute top-1/2 left-full h-0.5 w-full bg-[#e8f5e9] -translate-y-1/2 hidden md:block" data-id="element-596"></div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-597">
                Gentle Extraction
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-598">
                We use steam distillation and cold pressing to extract oils
                without chemical solvents, preserving their therapeutic
                properties.
              </p>
            </div>
            <div className="text-center" data-id="element-599">
              <div className="w-16 h-16 bg-[#f0f7eb] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-600">
                <span className="text-[#2e7d32] font-bold text-xl" data-id="element-601">4</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-602">
                Quality Testing
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-603">
                Each batch is tested for purity and potency before being
                carefully bottled and delivered to our customers.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 bg-white" data-id="element-604">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-605">
          <div className="max-w-4xl mx-auto bg-[#f0f7eb] rounded-2xl p-12 text-center" data-id="element-606">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-607">
              Experience the Shiriaka Difference
            </h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-608">
              Discover our collection of premium essential oils and start your
              journey to natural wellbeing today.
            </p>
            <Link to="/products" className="inline-flex items-center justify-center px-8 py-3.5 bg-[#2e7d32] text-white font-medium rounded-lg hover:bg-[#1b5e20] transition-colors duration-300" data-id="element-609">
              Shop Our Collection
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default About;